import helper from '@/constants/helper';
import { saveLastVisitedPage } from '@utils/saveLastVisitedPage';
import { Redirect, Route } from 'react-router';

const PrivateRoute = ({ children, ...props }) => {
  const isAuthenticated = localStorage.getItem(helper.JWT_TOKEN);

  return (
    <Route
      {...props}
      render={(_) => {
        if (!isAuthenticated) {
          saveLastVisitedPage();
          return <Redirect to='/login' />;
        }
        return children;
      }}
    />
  );
};

export default PrivateRoute;
